<template>
  <div v-if="isLoading">
    <v-skeleton-loader
      type="heading@2"
      class="breadcrumbs-skeleton-loader"
    />
  </div>
  <div v-else class="breadcrumbs-wrapper">
    <div class="breadcrumb-first-level">
      {{ firstLevelBreadCrumb }}
      <span class="breadcrumb-separator">/</span>
    </div>
    <BreadCrumbsDropdown
      :menu-pages="menuPages"
      :columns="columns"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import BreadCrumbsDropdown from '@/components/shared/BreadCrumbsDropdown.vue';

defineProps({
  isLoading: { type: Boolean, default: false },
  menuPages: { type: Array, default: () => [] },
  columns: { type: Number, default: 3 },
});

// Router
const route = useRoute();

const firstLevelBreadcrumbExceptions = {
  Team: 'Settings',
};

const firstLevelBreadCrumb = computed(() => {
  const title = route.meta.parentTitle;

  return firstLevelBreadcrumbExceptions[title] || title;
});
</script>

<style scoped lang="less">
.breadcrumbs-skeleton-loader {
  display: flex;
  flex-wrap: unset;
  background: transparent;
  width: 300px;
}

:deep(.v-skeleton-loader__heading) {
  margin: 0 16px;

  &:first-child {
    margin-left: 0;
  }
}

.breadcrumbs-wrapper {
  display: flex;
  align-items: center;
}

.breadcrumb-first-level {
  font-size: 13px;
  font-weight: 500;
  color: @text-dark;
  line-height: 20px;
}

.breadcrumb-separator {
  font-size: 13px;
  font-weight: 500;
  color: @grey-500;
  margin: 0 8px;
}
</style>
